<div *ngIf="isVisible" class="file-preview-overlay" (click)="close()">
  <div class="file-preview-panel" (click)="$event.stopPropagation()">
    <div class="file-preview-header">
      <ion-icon name="document-outline" class="file-icon"></ion-icon>
      <span class="file-name">{{ fileName }}</span>
      <button *ngIf="!isLoading" class="action-btn" (click)="download()" title="Download">
        <ion-icon name="cloud-download-outline"></ion-icon>
      </button>
      <button class="action-btn" (click)="close()" title="Close (ESC)">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
    <div class="file-preview-content">
      <div *ngIf="isLoading" class="preview-loading">
        <ion-spinner name="crescent"></ion-spinner>
        <p>Loading preview…</p>
      </div>
      <img
        *ngIf="!isLoading && isImage"
        [src]="safeImageUrl"
        [alt]="fileName"
        class="preview-image"
      />
      <iframe
        *ngIf="!isLoading && isPdf"
        [src]="safePdfUrl"
        class="preview-pdf"
      ></iframe>
      <div *ngIf="!isLoading && !isImage && !isPdf" class="preview-unsupported">
        <p>Preview not available for this file type.</p>
        <button (click)="download()">Download {{ fileName }}</button>
      </div>
    </div>
  </div>
</div>
